import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Link, Typography, SvgIcon } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import PropTypes from 'prop-types';

const BackButton = ({ path = -1 }) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    // Check if there's a saved scroll position to restore
    const savedScrollPosition = sessionStorage.getItem('queryPageScrollPosition');

    if (savedScrollPosition && typeof path === 'string') {
      // Navigate to the specific path with state to indicate scroll restoration
      navigate(path, { state: { restoreScroll: true, scrollPosition: parseInt(savedScrollPosition, 10) } });
    } else {
      // Default navigation
      navigate(path);
    }
  };

  return (
    <div>
      <Link
        color="text.primary"
        onClick={handleBackClick}
        sx={{
          alignItems: 'center',
          display: 'inline-flex',
          mb: 2,
        }}
        underline="hover"
      >
        <SvgIcon sx={{ mr: 1 }}>
          <ArrowBack />
        </SvgIcon>
        <Typography variant="subtitle2">Back</Typography>
      </Link>
    </div>
  );
};

BackButton.propTypes = {
  path: PropTypes.string.isRequired,
};

export default BackButton;
